/**
 * EndpointError — referans-parite
 * (features/platform/types/EndpointError.ts).
 *
 * HTTP isteği başarısız olduğunda fırlatılan hata sınıfı. Mesajda sayısal
 * kimlikler gizlilik için maskelenir.
 */

import type { HttpMethod } from "@app/features/platform/types/TransportTypes";

export interface HttpErrorDetail {
  method: HttpMethod;
  path: string;
  status: number;
  body?: unknown;
  rawText?: string;
  responseHeaders?: Record<string, string>;
}

export class HttpError extends Error {
  readonly method: HttpMethod;
  readonly path: string;
  readonly status: number;
  readonly body: unknown;
  readonly rawText?: string;
  readonly responseHeaders: Record<string, string>;

  constructor(detail: HttpErrorDetail) {
    super(`[${detail.status}] ${detail.method} ${redactNumericIds(detail.path)}`);
    this.name = "HttpError";
    this.method = detail.method;
    this.path = detail.path;
    this.status = detail.status;
    this.body = detail.body;
    this.rawText = detail.rawText;
    this.responseHeaders = detail.responseHeaders ?? {};
  }
}

/** Yoldaki uzun sayısal kimlikleri ":id" ile maskeler. */
function redactNumericIds(path: string): string {
  return path.replace(/\/(\d{5,})/g, () => "/:id");
}
